export const BASE_URL = process.env.NODE_ENV === 'development'
  ? 'https://integ.lili.co/lili/api/'
  : '/lili/api/'

class HttpService {
  get = (endpoint, data = null, header, shouldAllowCookie = null, token = null) => {
    return this.ajax(endpoint, data, header, 'GET', shouldAllowCookie, token)
  }
  post = (endpoint, data = null, header, shouldAllowCookie = null, token = null) => {
    return this.ajax(endpoint, data, header, 'POST', shouldAllowCookie, token)
  }
  put = (endpoint, data = null, header, shouldAllowCookie = null, token = null) => {
    return this.ajax(endpoint, data, header, 'PUT', shouldAllowCookie, token)
  }
  delete = (endpoint, data = null, header, shouldAllowCookie = null, token = null) => {
    return this.ajax(endpoint, data, header, 'DELETE', shouldAllowCookie, token)
  }

  ajax = async (endpoint, data, header, method, shouldAllowCookie, token) => {
    try {
      let response
      if (method.toLowerCase() === 'get') {
        response = await fetch(`${BASE_URL}${endpoint}`, {
          method,
          timeout: 90000,
          credentials: shouldAllowCookie ? 'same-origin' : 'omit',
          keepalive: true,
          headers: header
              ? {
                [header.headerName]: header.headerValue,
                ...(token && {'Authorization': 'lili ' + token}),
                'Content-Type': 'application/json'
              }
              : {
                'Content-Type': 'application/json'
              }
        })
      } else {
        response = await fetch(`${BASE_URL}${endpoint}`, {
          credentials: shouldAllowCookie ? 'same-origin' : 'omit',
          keepalive: true,
          timeout: 90000,
          body: JSON.stringify(data),
          method,
          headers: header
              ? {
                [header.headerName]: header.headerValue,
                ...(token && {'Authorization': 'lili ' + token}),
                'Content-Type': 'application/json'
              }
              : {
                'Content-Type': 'application/json'
              }
        })
      }

      if (!response.ok) {
        throw response
      }

      try {
        return await response.json()
      } catch (e) {
        return null
      }
    } catch (error) {
      let parsedData
      try {
        parsedData = await error.json()
      } catch (e) {
        parsedData = null
      }

      const errorObj = {rawError: error, data: parsedData}
      throw (errorObj)
    }
  }
}

const HTTP = new HttpService()
Object.freeze(HTTP)
export default HTTP



// WEBPACK FOOTER //
// ./src/services/HttpService.js